import { tv } from 'tailwind-variants';

export type ButtonVariant = 'primary' | 'secondary' | 'tertiary' | 'inverse';

export interface ButtonProperties {
  id?: string;
  text: string;
  type?: 'button' | 'submit' | 'reset';
  onClick?: () => void;
  variant?: ButtonVariant;
  classNames?: string;
  disabled?: boolean;
}

const button = tv({
  base: 'block w-full rounded-lg px-4 py-3.5 text-base font-bold leading-5 border transition-colors disabled:cursor-not-allowed disabled:bg-neutral-light disabled:border-neutral-light disabled:text-neutral',
  variants: {
    variant: {
      // Primary: azul escuro (#001234) → hover: azul médio (#667185)
      primary:
        'bg-primary border-primary text-neutral-lightest hover:bg-primary-light hover:border-primary-light',
      // Secondary: stroke azul escuro, fundo branco → hover: fundo azul escuro
      secondary:
        'bg-neutral-lightest border-primary text-primary hover:bg-primary hover:border-primary hover:text-neutral-lightest',
      // Tertiary: teal (#3F8A97) → hover: teal escuro (#204C50)
      tertiary:
        'bg-support2-medium border-support2-medium text-neutral-lightest hover:bg-support2-darkest hover:border-support2-darkest',
      // Inverse: stroke branco sobre fundo escuro → hover: fundo branco, texto escuro
      inverse:
        'bg-transparent border-neutral-lightest text-neutral-lightest hover:bg-neutral-lightest hover:text-primary',
    },
  },
  defaultVariants: {
    variant: 'primary',
  },
});

const span = (loading: string) =>
  loading === 'Aguarde...' ? (
    <>
      <span className="spinner-grow spinner-grow-sm" aria-hidden="true" />
      <span role="status">{loading}</span>
    </>
  ) : (
    loading
  );

const Btn = ({
  id,
  text,
  type,
  variant,
  classNames,
  onClick,
  disabled,
  ...props
}: ButtonProperties) => (
  <div id="mp__button" className="w-full">
    <button
      id={id}
      className={button({ variant, class: classNames })}
      onClick={onClick}
      type={type}
      {...props}
      disabled={disabled}
    >
      {span(text)}
    </button>
  </div>
);

export default Btn;
